var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',{on:{"click":_vm.changeTitle}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }